export default "__VITE_ASSET__F$Y8hMcX__"